import { gql } from '@apollo/client';

export const GET_CLINIC = gql`
  query queryClinicMyInfo {
    queryClinicMyInfo {
      email: identifier
      serial
      name
      ceoName: ceo
      additionalAddress: apt
      streetAddress
      city
      zip: zipCode
      phone
      website: web
      fax
    }
  }
`;

export const UPDATE_CLINIC = gql`
  mutation updateClinicMyInfo($input: ClinicUpdateInfoInput!) {
    updateClinicMyInfo(input: $input) {
      id
      identifier
      serial
      name
      ceo
      apt
      streetAddress
      city
      zipCode
      phone
      web
      fax
    }
  }
`;

export const GET_NOTICES = gql`
  query queryClinicNoticeList($input: ClinicNoticeListInput!) {
    queryClinicNoticeList(input: $input) {
      list {
        id
        title
        contents
        createdAt
        imageUris
      }
      page {
        pageNumber
        totalElements
      }
    }
  }
`;

export const GET_NOTICE_BY_ID = gql`
  query queryClinicNoticeById($input: Long!) {
    queryClinicNoticeById(input: $input) {
      id
      title
      contents
      createdAt
      imageUris
    }
  }
`;
